(function (global) {
  "use strict";

  var STORAGE_KEY = "p4p-theme";
  var VALID_THEMES = { dark: true, light: true };

  function getStoredTheme() {
    var stored = localStorage.getItem(STORAGE_KEY);
    return VALID_THEMES[stored] ? stored : "dark";
  }

  function getRoot() {
    return document.documentElement;
  }

  function applyTheme(theme, animate) {
    var root = getRoot();
    root.classList.remove("theme-dark", "theme-light");
    root.classList.add("theme-" + theme);

    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute(
        "content",
        theme === "light" ? "#FDFBF7" : "#0B0E14",
      );
    }

    document.querySelectorAll("[data-theme-toggle]").forEach(function (button) {
      var isLight = theme === "light";
      button.setAttribute("aria-pressed", isLight ? "true" : "false");
      button.setAttribute(
        "aria-label",
        isLight ? "Switch to dark blueprint theme" : "Switch to light theme",
      );

      var icon = button.querySelector("[data-theme-toggle-icon]");
      if (icon) icon.textContent = isLight ? "☾" : "☀";

      var label = button.querySelector("[data-theme-toggle-label]");
      if (label) label.textContent = "Theme";
    });

    if (animate) {
      root.classList.add("theme-morphing");
      window.setTimeout(function () {
        root.classList.remove("theme-morphing");
      }, 450);
    }
  }

  function setTheme(theme, animate) {
    if (!VALID_THEMES[theme]) return;
    localStorage.setItem(STORAGE_KEY, theme);
    applyTheme(theme, animate !== false);
  }

  function toggleTheme() {
    var next = getStoredTheme() === "dark" ? "light" : "dark";
    setTheme(next, true);
  }

  function bindToggleButtons() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-theme-toggle]");
      if (!button) return;

      event.preventDefault();
      button.classList.add("theme-toggle-btn--click");
      window.setTimeout(function () {
        button.classList.remove("theme-toggle-btn--click");
      }, 180);
      toggleTheme();
    });
  }

  function init() {
    applyTheme(getStoredTheme(), false);
    bindToggleButtons();
  }

  global.P4PTheme = {
    get: getStoredTheme,
    set: setTheme,
    toggle: toggleTheme,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(typeof window !== "undefined" ? window : this);
